export const handleError = (error: any) => {
  console.error('An error occurred:', error.message);
  throw new Error(error.message || 'An unexpected error occurred.');
};
